import { render, staticRenderFns } from "./AncestrylineProgressBar.vue?vue&type=template&id=045e60c3&scoped=true&"
import script from "./AncestrylineProgressBar.vue?vue&type=script&lang=js&"
export * from "./AncestrylineProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e60c3",
  null
  
)

export default component.exports